module.exports = __webpack_public_path__ + "images/home/index/templates-market-760b44d4965df59aed64253540b3e74e.png";